import { render, staticRenderFns } from "./InstallPrompt.vue?vue&type=template&id=7303b8b0&"
import script from "./InstallPrompt.vue?vue&type=script&lang=js&"
export * from "./InstallPrompt.vue?vue&type=script&lang=js&"
import style0 from "./InstallPrompt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports